import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { auth } from "../../../../../config/firebaseConfig";
import { useAuthState } from "react-firebase-hooks/auth";
import { isUnverifiedEmailUser } from "../../../../../utils/AuthLayout";
import EmailLoginForm from "./EmailLoginForm";
import EmailRegisterForm from "./EmailRegisterForm";
import EmailVerificationSentView from "./EmailVerificationSentView";

const IndividualEmailFlow = ({ getDashboardTargetUrl }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { schoolId } = useParams();
  const [currentUser] = useAuthState(auth);

  const isLoginMode = location.pathname.startsWith("/login");
  const [verificationData, setVerificationData] = useState(null);

  const handleVerificationSent = (data) => {
    setVerificationData(data);
  };

  const handleUnverified = (email, password = "") => {
    setVerificationData({ email, name: "", registerAs: "parent", password });
  };

  const handleBackToForm = async () => {
    setVerificationData(null);
    try {
      await auth.signOut();
    } catch (_) {}
    navigate("/login/email" + (location.search || ""));
  };

  // User is pending verification if we have local flow state
  // OR if Firebase Auth already has an unverified email/password user session
  const isPendingVerification = Boolean(
    verificationData?.email || isUnverifiedEmailUser(currentUser)
  );

  if (isPendingVerification) {
    const activeEmail = verificationData?.email || currentUser?.email || "";
    const activeName = verificationData?.name || currentUser?.displayName || "";
    const activeRegisterAs = verificationData?.registerAs || "parent";
    const activePassword = verificationData?.password || "";

    return (
      <EmailVerificationSentView
        email={activeEmail}
        name={activeName}
        registerAs={activeRegisterAs}
        password={activePassword}
        schoolId={schoolId}
        onBack={handleBackToForm}
        getDashboardTargetUrl={getDashboardTargetUrl}
      />
    );
  }

  if (isLoginMode) {
    return (
      <EmailLoginForm
        onBack={() => navigate("/login" + (location.search || ""))}
        onSwitchToRegister={() => navigate("/register/email" + (location.search || ""))}
        onUnverified={handleUnverified}
        getDashboardTargetUrl={getDashboardTargetUrl}
      />
    );
  }

  return (
    <EmailRegisterForm
      onBack={() => navigate("/register" + (location.search || ""))}
      onSwitchToLogin={() => navigate("/login/email" + (location.search || ""))}
      onVerificationSent={handleVerificationSent}
    />
  );
};

export default IndividualEmailFlow;
